import { Widget } from "./Widget";
import { FC } from "react";

type Props = {
  widgetProps: {
    title: string;
    className?: string;
    subTitle?: string;
  };
  chartProps: {
    ChartComponent: any;
    chartOptions: any;
  };
};

export const WidgetChart: FC<Props> = ({ widgetProps, chartProps }) => {
  const { ChartComponent, chartOptions } = chartProps;
  return (
    <Widget {...widgetProps}>
      <ChartComponent {...chartOptions} />
    </Widget>
  );
};
